import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/videos';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileOpen(false);
  }, [location]);

  const navLinks = [
    { label: '首页', path: '/' },
    { label: '电视剧', path: '/category/dianshi' },
    { label: '电影', path: '/category/dianying' },
    { label: '综艺', path: '/category/zongyi' },
    { label: '动漫', path: '/category/dongman' },
    { label: '直播', path: '/category/zhibo' },
    { label: '资讯', path: '/category/zixun' },
    { label: '关于我们', path: '/about' },
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <nav className="max-w-[1280px] mx-auto px-4 md:px-6 flex items-center justify-between h-16" role="navigation" aria-label="主导航">
        <Link to="/" className="flex items-center gap-2 group" aria-label="红桃tv首页">
          <div className="w-9 h-9 bg-primary-500 rounded-lg flex items-center justify-center group-hover:bg-primary-600 transition-colors">
            <i className="ri-heart-fill text-background-50 text-lg"></i>
          </div>
          <span className="font-heading text-xl text-foreground-900">
            红桃tv
          </span>
        </Link>

        <div className="hidden lg:flex items-center gap-1">
          {navLinks.map((link) => {
            const isActive = location.pathname === link.path || (link.path !== '/' && location.pathname.startsWith(link.path));
            return (
              <Link
                key={link.path}
                to={link.path}
                className={`px-3 py-2 rounded-md text-sm font-medium transition-colors whitespace-nowrap ${
                  isActive
                    ? 'text-primary-500 bg-primary-50'
                    : 'text-foreground-700 hover:text-foreground-900 hover:bg-background-100'
                }`}
              >
                {link.label}
              </Link>
            );
          })}
        </div>

        <div className="hidden lg:flex items-center gap-3">
          <button className="px-4 py-2 text-sm font-medium text-foreground-700 hover:text-foreground-900 rounded-md hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer" aria-label="搜索">
            <i className="ri-search-line mr-1"></i>
            搜索
          </button>
          <Link
            to="/about"
            className="px-5 py-2 text-sm font-medium text-background-50 bg-primary-500 hover:bg-primary-600 rounded-md transition-colors whitespace-nowrap"
          >
            下载APP
          </Link>
        </div>

        <button
          className="lg:hidden w-9 h-9 flex items-center justify-center text-foreground-700 hover:text-foreground-900 cursor-pointer"
          onClick={() => setIsMobileOpen(!isMobileOpen)}
          aria-label="打开菜单"
        >
          <i className={`text-xl ${isMobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </nav>

      {isMobileOpen && (
        <div className="lg:hidden bg-background-50 border-b border-background-200/70">
          <div className="px-4 py-3 flex flex-col gap-1">
            {navLinks.map((link) => {
              const isActive = location.pathname === link.path || (link.path !== '/' && location.pathname.startsWith(link.path));
              return (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`px-3 py-2.5 rounded-md text-sm font-medium transition-colors ${
                    isActive
                      ? 'text-primary-500 bg-primary-50'
                      : 'text-foreground-700 hover:text-foreground-900 hover:bg-background-100'
                  }`}
                >
                  {link.label}
                </Link>
              );
            })}
            <div className="border-t border-background-200/70 mt-1 pt-2 flex gap-2">
              <button className="flex-1 px-4 py-2 text-sm font-medium text-foreground-700 border border-background-300 rounded-md hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer">
                <i className="ri-search-line mr-1"></i>搜索
              </button>
              <Link
                to="/about"
                className="flex-1 px-4 py-2 text-sm font-medium text-background-50 bg-primary-500 hover:bg-primary-600 rounded-md text-center transition-colors whitespace-nowrap"
              >
                下载APP
              </Link>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}